/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingPlatform } from './';
import {
    BillingPlatformFromJSON,
    BillingPlatformFromJSONTyped,
    BillingPlatformToJSON,
} from './';
import type { EProcurementPlatform } from './';
import {
    EProcurementPlatformFromJSON,
    EProcurementPlatformFromJSONTyped,
    EProcurementPlatformToJSON,
} from './';
import type { InvoicingModeResource } from './';
import {
    InvoicingModeResourceFromJSON,
    InvoicingModeResourceFromJSONTyped,
    InvoicingModeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvoicingSettings
 */
export interface InvoicingSettings {
    /**
     * 
     * @type {InvoicingModeResource}
     * @memberof InvoicingSettings
     */
    invoicingMode: InvoicingModeResource;
    /**
     * 
     * @type {boolean}
     * @memberof InvoicingSettings
     */
    isSubcontracting?: boolean;
    /**
     * 
     * @type {EProcurementPlatform}
     * @memberof InvoicingSettings
     */
    eprocPlatform?: EProcurementPlatform;
    /**
     * 
     * @type {BillingPlatform}
     * @memberof InvoicingSettings
     */
    billingPlatform?: BillingPlatform;
    /**
     * 
     * @type {string}
     * @memberof InvoicingSettings
     */
    extraInformation?: string;
}

/**
 * Check if a given object implements the InvoicingSettings interface.
 */
export function instanceOfInvoicingSettings(value: object): value is InvoicingSettings {
    if (!('invoicingMode' in value) || value['invoicingMode'] === undefined) return false;
    return true;
}

export function InvoicingSettingsFromJSON(json: any): InvoicingSettings {
    return InvoicingSettingsFromJSONTyped(json, false);
}

export function InvoicingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'invoicingMode': InvoicingModeResourceFromJSON(json['invoicingMode']),
        'isSubcontracting': json['isSubcontracting'] == null ? undefined : json['isSubcontracting'],
        'eprocPlatform': json['eprocPlatform'] == null ? undefined : EProcurementPlatformFromJSON(json['eprocPlatform']),
        'billingPlatform': json['billingPlatform'] == null ? undefined : BillingPlatformFromJSON(json['billingPlatform']),
        'extraInformation': json['extraInformation'] == null ? undefined : json['extraInformation'],
    };
}

export function InvoicingSettingsToJSON(value?: InvoicingSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoicingMode': InvoicingModeResourceToJSON(value['invoicingMode']),
        'isSubcontracting': value['isSubcontracting'],
        'eprocPlatform': EProcurementPlatformToJSON(value['eprocPlatform']),
        'billingPlatform': BillingPlatformToJSON(value['billingPlatform']),
        'extraInformation': value['extraInformation'],
    };
}

